//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'VehicleProvisionStatisticsTable',
  props: {
    records: {
      type: Array,
      required: true
    },
    intervalType: {
      type: String,
      required: true
    },
    future: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      columns: [
        {
          name: 'name',
          label: this.future ? 'План (День/Ночь)' : 'Архивные данные (День/Ночь)',
          labelTable: this.future ? 'План<br>(День/Ночь)' : 'Архивные<br>данные<br>(День/Ночь)',
          align: 'center',
          field: 'name',
          sortable: false,
          style: 'width: 148px;'
        },
        {
          name: 'orderedDailyCount',
          label: 'Количество заказанных суточных АГП',
          labelTable: 'Кол-во<br>заказанных<br>суточных АГП',
          align: 'center',
          field: 'orderedDailyCount',
          sortable: false
        },
        {
          name: 'idlingDailyCount',
          label: 'Количество простаивающих суточных АГП',
          labelTable: 'Кол-во<br>простаивающих<br>суточных АГП',
          align: 'center',
          field: 'idlingDailyCount',
          sortable: false
        },
        {
          name: 'orderedAdditionalCount',
          label: 'Количество заказанных дополнительных АГП',
          labelTable: 'Кол-во<br>заказанных<br>дополнительных АГП',
          align: 'center',
          field: 'orderedAdditionalCount',
          sortable: false
        },
        {
          name: 'otherOrderedAdditionalCount',
          label: 'Иные дополнительные АГП',
          labelTable: 'Иные<br>дополнительные АГП',
          align: 'center',
          field: 'otherOrderedAdditionalCount',
          sortable: false
        }
      ],
      pagination: {
        page: 1,
        rowsPerPage: 0 // все строки
      }
    }
  }
}

